export default "__VITE_ASSET__BGoaVJpr__"